import { HttpClient } from "@angular/common/http";
import { API_CONSTANT } from "./api.constant";
import { HttpClientService } from "./http-client.service";
var CustomerService = (function () {
    function CustomerService(http, httpService) {
        this.http = http;
        this.httpService = httpService;
    }
    CustomerService.prototype.getTaxData = function (secretCode) {
        return this.http.get("" + API_CONSTANT.tax_data + secretCode + "/");
    };
    CustomerService.prototype.approveTaxData = function (secretCode) {
        return this.http.post("" + API_CONSTANT.tax_data + secretCode + "/approve/", {});
    };
    CustomerService.prototype.userApproveTaxData = function (secretCode) {
        return this.httpService.post("" + API_CONSTANT.tax_data + secretCode + "/approve/", {});
    };
    CustomerService.prototype.rejectTaxData = function (secretCode, payload) {
        return this.http.post("" + API_CONSTANT.tax_data + secretCode + "/reject/", payload);
    };
    return CustomerService;
}());
export { CustomerService };



// WEBPACK FOOTER //
// /opt/app/src/app/services/customer.service.ts.pre-build-optimizer.js